import React, { useState, useEffect } from "react";
import { I18nProvider } from "../../i18n";
import { settings } from '../../settings'
import translate from "../../i18n/translate";
import $ from "jquery";
import gsap from "gsap";
import { useRef } from 'react';

import "./CourbeAbout.css";
import CircleModals from "../CircleModals";

export default function CourbeAboutSVG({ isMobile, locale, setSelectedGallerySrc }) {

    const linePath = useRef(null);
    const [exps, setExps] = useState();
    const [openExpModal, setOpenExpModal] = useState(false);
    const [selectedExp, setSelectedExp] = useState(null);
    const handleOpenExpModal = (exp) => {
        setSelectedExp(exp)
        setOpenExpModal(true);
    };
    const handleCloseExpModal = () => {
        setOpenExpModal(false);
    };

    const CircleEnter = (e) => {
        e.target.style.r = 16;
    };
    const CircleLeave = (e) => {
        e.target.style.r = 13;
    };

    let ratio;

    const handleScroll = (event) => {
        var scroll = $("#scroller").scrollTop();
        var h = $("#scollForcer").height();
        var hS = $("#scroller").height();
        ratio = scroll / (h - hS);

        for (let i = 0; i < settings.exps?.length; i++) {
            let step = 1 / settings.exps?.length * i
            if (ratio > step) {
                $("#expsCircle" + i).css("r", 13);
                gsap.to("#expsText" + i, {
                    fontSize: 55,
                    duration: 0.5,
                    ease: "back.easeOut",
                });
            } else {
                $("#expsCircle" + i).css("r", 0);
                gsap.to("#expsText" + i, {
                    fontSize: 0,
                    duration: 0.5,
                    ease: "back.easeOut",
                });
            }
        }

        $(".courbe").css("stroke-dashoffset", 2350 - 2350 * ratio);

        if (ratio >= 0.98) {
            //End animation
            $(".courbe").css("stroke-dashoffset", 0);
            $("#scollForcer").remove();
            $("#scroller").css("overflow", "visible");
            $("#scroller").css("height", "50vh");
            $("#scroller").css("overflow", "visible");
        }

        if (ratio >= 0.15) {
            gsap.timeline({}).to("#scollIndicator", { opacity: 0, duration: 1 });
        }
        if (ratio <= 0.15) {
            gsap.timeline({}).to("#scollIndicator", { opacity: 1, duration: 1 });
        }
    };

    /* setInterval(function () {
        for (let i = 0; i < settingsExps?.length; i++) {
            if (ratio >= (1 / (settingsExps.length + 1)) * i + 0.04) {
                gsap
                    .timeline({})
                    .to("#expsCircle" + i, {
                        r: 18,
                        ease: "Back.easeInOut",
                        duration: 0.3,
                        delay: 1.1 * i,
                    })
                    .to("#expsCircle" + i, {
                        r: 13,
                        ease: "Back.easeInOut",
                        duration: 0.3,
                        delay: 0.5
                    });
            }
        }
    }, settingsExps.length * 1500); */


    useEffect(() => {
        gsap
            .timeline({})
            .fromTo(
                "#scrollText",
                { strokeDashoffset: 250 },
                { strokeDashoffset: -250, duration: 3.5, repeat: -1 }
            );
        gsap.timeline({}).fromTo(
            "#arrowDownIndicator",
            { opacity: 1, translateY: -40 },
            {
                opacity: 0.5,
                translateY: -65,
                duration: 2,
                repeat: -1,
                yoyo: true,
            }
        );

        for (let i = 0; i < settings.exps.length; i++) {
            let point = linePath.current?.getPointAtLength((linePath.current?.getTotalLength() / settings.exps.length) * i + 1)
            settings.exps[i].x = Math.floor(point.x);
            settings.exps[i].y = Math.floor(point.y);

        }
        if (!exps) {
            setExps(settings.exps);
        }
    });

    return (
        <div id="scroller" onScroll={handleScroll}>
            <div id="scollForcer"></div>
            <div id="svgPosition">
                <svg
                    id="courbeAboutSVG"
                    data-name="Calque 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1920 1080"
                >
                    <clipPath id="clip">
                        <path
                            className="pathfinder"
                            d="M1630.65,979.35c-4.27,0-8.55-.11-12.71-.34l.33-6c4,.22,8.22.33,12.38.33h0c5.6,0,11.38-.2,17.18-.6l.41,6c-5.94.41-11.86.61-17.59.61Zm-42.87-4.24a172.45,172.45,0,0,1-29.19-8.82l2.25-5.56a166.43,166.43,0,0,0,28.17,8.5Zm90.59,0-1-5.92c9.41-1.6,19.2-3.71,29.09-6.25l1.49,5.82C1697.89,971.31,1687.94,973.45,1678.37,975.09ZM1737,960.2l-1.88-5.7c9.14-3,18.58-6.45,28-10.19l2.21,5.58C1755.75,953.68,1746.2,957.15,1737,960.2Zm-205.44-8a161.75,161.75,0,0,1-23.88-19l4.15-4.33a155.22,155.22,0,0,0,23,18.28ZM1793.1,938.1l-2.47-5.46c8.87-4,17.94-8.38,26.95-12.94l2.71,5.35C1811.21,929.65,1802.06,934,1793.1,938.1Zm53.81-27.21-2.92-5.24c8.64-4.81,17.34-9.88,25.87-15.06l3.12,5.13C1864.38,900.94,1855.61,906,1846.91,910.89Zm-359.36-.56c-3.46-4.67-6.83-9.65-10-14.8-2.16-3.51-4.37-7-6.56-10.43l5-3.24c2.21,3.44,4.44,7,6.62,10.53,3.08,5,6.35,9.84,9.71,14.37Zm410.93-30.74-3.31-5c14.52-9.58,23-16,23.14-16l3.6,4.8C1921.82,863.42,1913.16,869.9,1898.48,879.59Zm-1545.25-.3c-10.42-.26-20.56-.94-30.16-2l.66-6c9.43,1,19.4,1.7,29.65,2Zm30.19-.32-.26-6c9.57-.42,19.57-1.14,29.74-2.15l.6,6C403.22,877.82,393.1,878.55,383.42,879Zm60-5.88-.87-5.93c9.54-1.4,19.45-3.06,29.46-4.93l1.1,5.9C463,870,453,871.68,443.4,873.09Zm-150.21-.7a222,222,0,0,1-29.14-8.52l2.09-5.62a216.52,216.52,0,0,0,28.35,8.28Zm209.39-10.3-1.3-5.85c9.45-2.1,19.24-4.42,29.1-6.91l1.46,5.82C521.93,857.65,512.09,860,502.58,862.09Zm951.67-1.68c-5.84-8.16-11.89-16.16-18-23.79l4.68-3.74c6.17,7.71,12.29,15.79,18.19,24ZM236.48,851a154,154,0,0,1-24.77-17.8l4-4.49a148,148,0,0,0,23.8,17.1Zm324.43-3.54-1.62-5.78c9.36-2.61,19-5.43,28.74-8.37l1.74,5.74C580,842,570.31,844.81,560.91,847.43ZM618.44,830l-1.86-5.7c9.32-3,18.88-6.23,28.4-9.51l1.95,5.67C637.38,823.76,627.79,827,618.44,830ZM1417,813.9c-6.71-7.44-13.64-14.68-20.61-21.52l4.2-4.28c7.06,6.92,14.08,14.25,20.86,21.78ZM191.1,810.64a155.51,155.51,0,0,1-15.57-26.22l5.43-2.55a149.8,149.8,0,0,0,15,25.21Zm484.15-.19-2-5.64c9.2-3.34,18.65-6.84,28.08-10.42l2.13,5.61C694,803.59,684.48,807.1,675.25,810.45Zm56.18-21.29-2.2-5.58c9.13-3.61,18.49-7.37,27.8-11.17L759.3,778C750,781.78,740.59,785.54,731.43,789.16Zm643-16.91c-7.56-6.49-15.39-12.74-23.26-18.58l3.58-4.82c8,5.93,15.92,12.27,23.59,18.84ZM787,766.44l-2.33-5.53c9-3.8,18.28-7.77,27.54-11.79l2.39,5.5C805.35,758.65,796.06,762.63,787,766.44ZM165,755.83a227.54,227.54,0,0,1-6.1-29.76l5.95-.82a220.75,220.75,0,0,0,5.93,29Zm677.11-13.3L839.67,737c8.62-3.84,17.4-7.8,26.11-11.78l1.08-.55,2.72,5.35-1.07.55-.16.08C859.6,734.68,850.77,738.67,842.11,742.53Zm484.53-5.72c-8.38-5.32-17-10.36-25.71-15l2.82-5.29c8.82,4.7,17.6,9.82,26.1,15.21Zm-429.89-19-2.28-5.55c9.08-3.74,18.58-7.34,28.22-10.72l2,5.67C915.13,710.54,905.74,714.1,896.75,717.8Zm377.41-9c-9-4-18.35-7.63-27.69-10.9l2-5.66c9.48,3.32,18.94,7,28.11,11.07ZM953.1,698l-1.69-5.76c9.62-2.83,19.43-5.46,29.13-7.8l1.41,5.83C972.34,692.63,962.63,695.23,953.1,698Zm-796.67-2.18c-.1-3.28-.15-6.64-.15-10,0-6.57.19-13.38.57-20.25l6,.33c-.37,6.76-.56,13.46-.56,19.92,0,3.3.05,6.6.14,9.82ZM1218,689.17c-9.5-2.55-19.26-4.78-29-6.63l1.12-5.9c9.9,1.89,19.81,4.15,29.45,6.73Zm-206.89-5.11-1.1-5.89c9.93-1.86,20-3.46,29.79-4.75l.79,6C1030.88,680.65,1021,682.23,1011.14,684.06Zm148.43-6c-9.72-1.14-19.71-2-29.69-2.48l.31-6c10.1.5,20.23,1.35,30.09,2.52Zm-89.28-1.7-.44-6c10.08-.75,20.22-1.2,30.15-1.33l.08,6C1090.27,675.13,1080.25,675.57,1070.29,676.31ZM165.56,636.24l-5.95-.75c1.21-9.66,2.78-19.69,4.65-29.82l5.9,1.09C168.31,616.78,166.76,626.69,165.56,636.24Zm10.79-58.71-5.84-1.38c2.26-9.54,4.81-19.36,7.59-29.18l5.78,1.63C181.12,558.34,178.59,568.08,176.35,577.53ZM192.59,520l-5.7-1.86c3.07-9.45,6.39-19,9.85-28.49l5.63,2.07C198.94,501.09,195.65,510.6,192.59,520Zm20.59-56.2-5.56-2.26c7-17.25,12-27.66,12.09-27.76l5.41,2.6C225.07,436.47,220.15,446.74,213.18,463.79Z"
                        />
                    </clipPath>
                    <path
                        ref={linePath}
                        clipPath="url(#clip)"
                        className="courbe"
                        d="M222.41,435.07S-138.89,1187,867.11,728c0,0,385.31-203.76,613,166,125,203,440-33,440-33"
                    />

                    {
                        exps &&
                        exps.map((exp, i) =>
                            <><circle
                                id={"expsCircle" + i}
                                onMouseEnter={CircleEnter}
                                onMouseLeave={CircleLeave}
                                onClick={() => handleOpenExpModal(exp)}
                                className="dotSVG"
                                r="0"
                                cx={exp.x}
                                cy={exp.y}>
                            </circle>
                                <text
                                    x={exp.x + (i === 1 || i === 5 ? 50 : 0)}
                                    y={i % 2 ? exp.y - 50 : exp.y - 50}
                                    id={"expsText" + i}
                                    fontFamily="Bahnschrift Regular"
                                    fill="white"
                                    textAnchor="middle"
                                    fontSize="0"
                                >
                                    {<I18nProvider locale={locale}>
                                        {translate(exp.id)}
                                    </I18nProvider>}
                                </text>
                            </>
                        )
                    }
                </svg>
            </div>
            {
                selectedExp &&
                <CircleModals
                    isMobile={isMobile}
                    locale={locale}
                    selectedExp={selectedExp}
                    openExpModal={openExpModal}
                    handleCloseExpModal={handleCloseExpModal}
                    handleOpenExpModal={handleOpenExpModal}
                    setSelectedGallerySrc={setSelectedGallerySrc}
                />
            }
        </div>
    );
}
